/**
 * Admin Layout Route.
 * Wraps all /admin and /admin/* child routes inside the enterprise AdminLayout
 * providing the sidebar navigation, top header, search, and RBAC guards.
 */

import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/layout/admin-layout";
import { supabase } from "@/lib/supabase";

export const Route = createFileRoute("/admin")({
  component: AdminRouteLayout,
});

function AdminRouteLayout() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
